import { awardWalletBadgeDetail } from '~/graphql/documents/awardWallet';
import { transformAwardWalletBadge } from '~/utils/transformers/badgeTransformers';
import { transformPagination } from '~/utils/transformers/paginationTransformers';

// API hooks
interface UseAwardWalletBadgeFetchDetailParams {
  slug: string;
}

export const useAwardWalletBadgeFetchDetail = (params: Ref<UseAwardWalletBadgeFetchDetailParams>) => {
  const { $urqlClient } = useNuxtApp();

  const variables = computed(() => ({
    filters: {
      slugs: [params.value.slug],
      hasPublishedCollection: true,
    },
  }));

  const { data, pending: isFetching, error } = useAsyncData(
    `award-badge-${params.value.slug}`,
    () => $urqlClient.query(awardWalletBadgeDetail, variables.value, { requestPolicy: 'cache-and-network' }).toPromise(),
    {
      watch: [variables],
      server: true,
      transform: (data) => {
        if (data.error) {
          throw data.error;
        }

        if (data.data?.badges.data.length === 0) {
          throw createError({
            statusCode: 404,
            statusMessage: 'Badge not found',
          });
        }

        return {
          data: data.data?.badges.data.map(item => transformAwardWalletBadge(item)) ?? [],
          paginatorInfo: transformPagination(data.data?.badges.paginatorInfo),
          stale: data.stale,
        };
      },

    },
  );

  const isStale = computed(() => data.value?.stale ?? false);
  const items = computed(() => data.value?.data ?? []);
  const paginatorInfo = computed(() => data.value?.paginatorInfo);

  return {
    items,
    paginatorInfo,
    isFetching,
    isStale,
    error,
  };
};
